(() => {
  if (window.lfExperienceReady) return;
  window.lfExperienceReady = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const motion = () => !reduced.matches && document.body.dataset.motion !== 'false' && !window.Shopify?.designMode;
  const selector = '[data-reveal], .section-head, .bio-chapter, .artist-photo-section figure, .lf-media-tile, .lf-product-description, .step';
  const observed = new WeakSet();
  let observer;
  const show = element => { element.classList.remove('reveal-pending'); element.classList.add('reveal-visible'); observer?.unobserve(element); };
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) show(entry.target);
    }), { threshold: 0.06, rootMargin: '0px 0px -4% 0px' });
  }
  function initialize(root = document) {
    const elements = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) elements.unshift(root);
    elements.forEach((element, index) => {
      if (observed.has(element)) return;
      observed.add(element);
      if (!motion() || !observer || element.closest('.hero') || element.parentElement.closest('.reveal-pending')) return;
      const rect = element.getBoundingClientRect();
      if (rect.top < innerHeight * .92) return;
      element.classList.add('reveal-pending');
      element.style.setProperty('--reveal-delay', `${Math.min(index % 4, 3) * 65}ms`);
      observer.observe(element);
    });
  }
  initialize();
  document.addEventListener('lf:section:updated', event => initialize(event.detail.root));
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    let element = event.target;
    while (element && element !== document.body) { show(element); element = element.parentElement; }
  });
  document.addEventListener('focusin', event => {
    const parent = event.target.closest('.reveal-pending');
    if (parent) show(parent);
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.querySelectorAll('.reveal-pending').forEach(show);
  });
  let scheduled = false;
  function updateHeader() {
    document.body.classList.toggle('is-scrolled', scrollY > 48);
    scheduled = false;
  }
  updateHeader();
  addEventListener('scroll', () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(updateHeader); }
  }, { passive: true });
  let activeTransition;
  addEventListener('pagereveal', event => {
    activeTransition = event.viewTransition;
    if (!motion()) activeTransition?.skipTransition();
  });
  const catalogURL = value => { try { const u = new URL(value, location.href); return /\/collections\//.test(u.pathname) || /\/(boutique|partitions|tablatures|packs)\.html$/.test(u.pathname); } catch { return false; } };
  addEventListener('pageswap', event => { if (!motion() || (catalogURL(location.href) && catalogURL(event.activation?.entry?.url))) event.viewTransition?.skipTransition(); });
  for (const type of ['pointerdown', 'keydown', 'wheel']) addEventListener(type, () => activeTransition?.skipTransition(), { passive: true });
  let navigating = false;
  document.addEventListener('click', event => {
    if (!motion() || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target || link.hasAttribute('download') || link.matches('[data-option-link], [data-pdf-preview], [data-video-embed], [data-no-transition], [data-catalog-link]')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !['http:', 'https:'].includes(url.protocol) || /\/(cart|checkout|account|challenge|admin)(\/|$)/.test(url.pathname)) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    if ('onpageswap' in window && 'onpagereveal' in window) return;
    if (navigating) return;
    event.preventDefault();
    navigating = true;
    try { sessionStorage.setItem('lfPageArrival', '1'); } catch {}
    const main = document.getElementById('MainContent');
    main?.animate?.([{ opacity: 1, transform: 'translateY(0)' }, { opacity: .88, transform: 'translateY(-5px)' }], { duration: 140, easing: 'ease-out', fill: 'forwards' });
    setTimeout(() => location.assign(url.href), 145);
  });
  function arrive() {
    navigating = false;
    updateHeader();
    const main = document.getElementById('MainContent');
    main?.getAnimations?.().forEach(animation => animation.cancel());
    try {
      if (sessionStorage.getItem('lfPageArrival') && motion()) main?.animate?.([{ transform: 'translateY(10px)' }, { transform: 'translateY(0)' }], { duration: 430, easing: 'cubic-bezier(.22,1,.36,1)' });
      sessionStorage.removeItem('lfPageArrival');
    } catch {}
  }
  addEventListener('pageshow', arrive);
})();
(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const pointer = matchMedia('(hover: hover) and (pointer: fine)');
 const motion = () => !reduced.matches && document.body.dataset.motion !== 'false';
 document.addEventListener('click', e => {
  const button = e.target.closest('[data-carousel-prev], [data-carousel-next]');
  if (!button) return;
  const track = button.closest('[data-carousel]').querySelector('[data-carousel-track]');
  const step = track.firstElementChild?.getBoundingClientRect().width || track.clientWidth * .8;
  track.scrollBy({left:(step + 24) * (button.hasAttribute('data-carousel-next') ? 1 : -1), behavior:motion() ? 'smooth' : 'auto'});
 });
 let lastTarget, frame;
 function reset(target) {
  for (const name of ['--pointer-x','--pointer-y','--tilt-x','--tilt-y','--shine-x','--shine-y']) target?.style.removeProperty(name);
 }
 document.addEventListener('pointermove', e => {
  if (!pointer.matches || !motion()) return;
  const target = e.target.closest('.desktop-nav a, .product-card');
  if (lastTarget !== target) reset(lastTarget);
  lastTarget = target;
  cancelAnimationFrame(frame);
  if (!target) return;
  frame = requestAnimationFrame(() => {
   const rect = target.getBoundingClientRect();
   const x = (e.clientX - rect.left) / rect.width - .5;
   const y = (e.clientY - rect.top) / rect.height - .5;
   target.style.setProperty('--pointer-x',`${x * 5}px`);
   target.style.setProperty('--pointer-y',`${y * 3}px`);
   target.style.setProperty('--tilt-x',`${-y * .8}deg`);
   target.style.setProperty('--tilt-y',`${x * .8}deg`);
   target.style.setProperty('--shine-x',`${(x + .5) * 100}%`);
   target.style.setProperty('--shine-y',`${(y + .5) * 100}%`);
  });
 }, {passive:true});
 document.addEventListener('pointerleave',() => {cancelAnimationFrame(frame);reset(lastTarget);lastTarget=null;});
 reduced.addEventListener('change',() => {cancelAnimationFrame(frame);reset(lastTarget);});
})();
